import { siteConfig } from '../lib/site-config'

export interface ServiceItem {
  title: string
  copy: string
  image: string
  alt: string
  href: string
}

export interface ReviewItem {
  quote: string
  author: string
  detail?: string
}

export interface TrustItem {
  title: string
  copy: string
  icon: 'history' | 'award' | 'location' | 'sparkle'
}

export interface PackageFeature {
  icon: 'clock' | 'droplet' | 'sun' | 'layers' | 'shield' | 'tool' | 'calendar' | 'diamond' | 'sparkle'
  label: string
}

export interface PackageCard {
  eyebrow: string
  title: string
  subtitle?: string
  fromLabel: string
  price: string
  features: PackageFeature[]
  cta: string
  href: string
  featured?: boolean
}

export interface GalleryItem {
  image: string
  alt: string
  caption?: string
}

export { primaryNavItems as navItems } from '../lib/public-routes'

export const heroContent = {
  logo: '/images/autoglow-logo-updated.png',
  headerLogo: '/images/autoglow-logo-updated.png',
  image: '/images/home-screen-image.webp',
  titlePrefix: 'PREMIUM CERAMIC COATING & PAINT CORRECTION',
  titleHighlight: 'BELLARINE & GEELONG',
  titleSuffix: '',
  copy: [
    'GYEON ceramic coatings and paint correction from the Drysdale studio, serving the Bellarine Peninsula and Geelong.',
    'Every vehicle is inspected and prepared in the studio before coating or correction — matched to the paint, not a generic package.',
  ],
  cta: 'Explore Ceramic Protection',
  ctaHref: '/ceramic-protection',
  secondaryCta: 'Request a Free Quote',
  secondaryCtaHref: '/contact',
  badgeLabel: 'GYEON Certified Studio',
}

export const trustStrip: TrustItem[] = [
  { title: '18+ Years', copy: 'Industry Experience', icon: 'history' },
  { title: 'GYEON Certified', copy: 'Elite Detailer Program', icon: 'award' },
  { title: 'Drysdale, VIC', copy: 'Specialist Local Studio', icon: 'location' },
  { title: 'Premium Finish', copy: 'Clinical Focus Studio', icon: 'sparkle' },
]

export const galleryItems: GalleryItem[] = [
  {
    image: '/images/blue-car-detailer.webp',
    alt: 'Autoglow detailer polishing a blue vehicle in the studio.',
  },
  {
    image: '/images/lyle-studio.jpg',
    alt: 'Lyle working in the Autoglow Detailing studio.',
  },
]

export const services: ServiceItem[] = [
  {
    title: 'GYEON CERAMIC PROTECTION',
    copy: 'Preserve and elevate the look of your vehicle with professional GYEON ceramic coatings designed for long-term protection.',
    image: '/images/gyeon-protection.jpg',
    alt: 'Water beading on a freshly ceramic-coated vehicle panel.',
    href: '/ceramic-protection',
  },
  {
    title: 'PAINT CORRECTION',
    copy: 'Reduce swirl marks, restore clarity and gloss, and prepare paint for ceramic coating. Correction is quoted after inspection — not as a promise of a perfect, defect-free finish.',
    image: '/images/paint-correction.jpg',
    alt: 'A professional detailer machine polishing a dark vehicle panel.',
    href: '/paint-correction',
  },
  {
    title: 'TAILORED DETAILING',
    copy: 'Premium professional car detailing using industry-leading tools and products, recommended after inspecting the vehicle rather than a fixed menu. Interior work is included as part of a fuller enhancement when the vehicle needs it.',
    image: '/images/home-page-mercedes-benz.png',
    alt: 'A luxury vehicle after professional studio detailing.',
    href: '/detailing',
  },
]

export const studioStats = [
  ['EXPERIENCE', '18+ YEARS'],
  ['STATUS', 'GYEON CERTIFIED'],
  ['LOCATION', 'DRYSDALE, VIC'],
]

export const reviews: ReviewItem[] = [
  {
    quote:
      "Lyle's attention to detail is truly world-class. My car looks better than the day I picked it up from the showroom. The ceramic coating finish is absolutely mirror-like.",
    author: 'James Donovan',
    detail: 'Verified Google Review',
  },
  {
    quote:
      'Highly recommend Autoglow for anyone on the Bellarine. Professional, clean studio, and outstanding results on my classic restoration.',
    author: 'Sarah Jenkins',
  },
  {
    quote:
      'The only person I trust with my vehicle. Expert knowledge and uses only the best GYEON products.',
    author: 'Mark Thompson',
  },
]

export const contactDetails = [
  { label: 'Studio Location', value: siteConfig.address },
  { label: 'Operational Hours', value: siteConfig.openingHours, note: 'Strictly By Appointment Only' },
  { label: 'Primary Line', value: siteConfig.phone },
]
